import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.all-users', {
        url: '/all-users',
        component: 'companyUserDirectoriesSaaspassUsersAllUsers',
        resolve: {
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/all-users.state.js